export default {
	root: ({ props }) => ({
		class: [
			"bg-white",
			"inline-flex select-none align-bottom outline-transparent gap-0.5 p-0.5",
			"rounded-md",

			// Invalid State
			{
				"ring-2 ring-red": props.invalid,
			},
		],
	}),
}
